import {
  MISSION_CONTROL_SEARCH_MIN_CHARS,
} from "./feedLimits";

/** Trimmed search string for list API calls; empty when below the minimum length. */
export function missionControlSearchQueryForApi(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed.length < MISSION_CONTROL_SEARCH_MIN_CHARS) return "";
  return trimmed;
}

/** Whether the toolbar search should filter rows / hit list endpoints. */
export function missionControlSearchIsActive(raw: string): boolean {
  return missionControlSearchQueryForApi(raw).length > 0;
}
